import React from 'react';
import { Modal, Table, Form, Input, Button, Space } from 'antd';
import { EditOutlined, PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import ButtonComp from '../button/ButtonComp';
import { useSelector } from 'react-redux';

const CustomFeilds = ({
    isCustomFieldEditMode,
    setIsCustomFieldEditMode,
    editableExterFieldData,
    showExtraFieldModal,
    isExtraFieldModalOpen,
    handleOkExtraField,
    handleCancelExtraFieldModal,
    form,
    handleFinishExtraField,
    handelCloseCustomFieldEditMode,
    customTabColumns,
}) => {
    const select = useSelector((state) => state.auth);
    const user_role = select.userInfo.role;
    return (
        <div>
            <div className=" text-black pb-3 px-2 flex items-center justify-between">
                <div className="agreement-details flex items-center gap-2">
                    <h1 className="font-semibold text-[15px] pt-[1%] dark:text-white">
                        Custom Fields
                    </h1>
                    {!isCustomFieldEditMode && !!editableExterFieldData.length
                        && (user_role && user_role.toLowerCase() === "admin" ||
                            user_role.toLowerCase() === "superadmin") && (
                            <div className="edit-icon">
                                <EditOutlined
                                    onClick={() => setIsCustomFieldEditMode(true)}
                                    className="h-4 ml-2 text-lg transform scale-125 dark:text-white"
                                />
                            </div>
                        )}
                </div>
                {(user_role && user_role.toLowerCase() === "admin") ||
                    user_role.toLowerCase() === "superadmin" ?
                    !isCustomFieldEditMode ? <ButtonComp
                        text="Add Custom Fields"
                        bgColor="#4E36A3"
                        textColor="white"
                        onClick={showExtraFieldModal}
                    /> : <div className="flex justify-between">
                        <div className="flex">
                            <ButtonComp
                                width="7em"
                                text={"Cancel"}
                                onClick={handelCloseCustomFieldEditMode}
                                margin={"4px"}
                                textColor="#4E36A3"
                            ></ButtonComp>
                            <ButtonComp
                                width="7em"
                                type="primary"
                                onClick={() =>
                                    handleFinishExtraField('editCustomField')
                                }
                                className=""
                                text={"Save"}
                                textColor="white"
                                bgColor="#4E36A3"
                            ></ButtonComp>
                        </div>
                    </div>
                    : (
                        ""
                    )}
                <Modal
                    title="Custom Fields"
                    open={isExtraFieldModalOpen}
                    onOk={handleOkExtraField}
                    onCancel={handleCancelExtraFieldModal}
                    footer={null}
                >
                    <Form
                        form={form}
                        name="dynamic_form_nest_item"
                        onFinish={handleFinishExtraField}
                        style={{
                            maxWidth: 600,
                        }}
                        autoComplete="off"
                    >
                        <Form.List name="extra_fields">
                            {(fields, { add, remove }) => (
                                <>
                                    {fields.map(({ key, name, ...restField }) => (
                                        <Space
                                            key={key}
                                            style={{
                                                display: "flex",
                                                marginBottom: 8,
                                            }}
                                            align="baseline"
                                        >
                                            <Form.Item
                                                {...restField}
                                                name={[name, "field"]}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Missing Particular name",
                                                    },
                                                ]}
                                            >
                                                <Input placeholder="Particular" />
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "value"]}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Missing value",
                                                    },
                                                ]}
                                            >

                                                <Input.TextArea placeholder="Details" />
                                            </Form.Item>
                                            <MinusCircleOutlined
                                                onClick={() => remove(name)}
                                            />
                                        </Space>
                                    ))}
                                    <Form.Item>
                                        <Button
                                            type="dashed"
                                            onClick={() => add()}
                                            block
                                            icon={<PlusOutlined />}
                                        >
                                            Add More fields
                                        </Button>
                                    </Form.Item>
                                </>
                            )}
                        </Form.List>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
            <Table
                dataSource={editableExterFieldData}
                columns={customTabColumns}
                pagination={false}
                scroll={{ x: "max-content" }}
                bordered
                className="text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"
            />
        </div>
    )
}

export default CustomFeilds
